import loadingIconSrc from '../../../../styles/assets/images/laoding-clock-white.gif';

const Prompt = props => {
    let { type, message } = props
    if (type === "loading") {
        return (
            <div className="prompt">
                <img src={loadingIconSrc} alt="loading" />
                <h4>{message}</h4>
            </div>
        )
    }

    if (type === "error") {
        return (
            <div className="prompt">
                <h4 style={{ color: "red" }}>
                    {message}
                </h4>
            </div>
        )
    }
}

export default Prompt